import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, config, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/users/user';
import { AppUser } from 'src/app/models/auth/app-user';
import { Router } from '@angular/router';
import { CommonListResponse } from 'src/app/models/common-list-response';
import { MasterService } from './masters.service';
import { MasterCommon } from 'src/app/models/masters/master-common';
import { IModel } from 'src/app/interfaces/model';
import { StorageService } from 'src/app/services/utils/storage.service';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  /** Claves de «Recuérdame». Sobreviven al logout; ver `limpiarConservandoCorreo`. */
  public static readonly REMEMBER_ME = 'RememberMe';
  public static readonly REMEMBERED_EMAIL = 'rememberedEmail';

  private currentUserSubject: BehaviorSubject<CommonListResponse<AppUser>>;
  public currentUser: Observable<CommonListResponse<AppUser>>;
  isUserLoggedIn: boolean = false;

  constructor(private router: Router,
    private masterService: MasterService<IModel>,
    private storageService: StorageService,
    private http: HttpClient,) {
    this.currentUserSubject = new BehaviorSubject<CommonListResponse<AppUser>>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): CommonListResponse<AppUser> {
    return this.currentUserSubject.value;
  }

  newPassword(item)
  {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': '*/*',
        Authorization: 'Bearer ' + sessionStorage.getItem('accessToken')
        //'X-XSRF-TOKEN': 'eyJpdiI6IjEvRy9sWkpnVGJiVGxGQ0NkbzRJaUE9PSIsInZhbHVlIjoiZFZXWDA1RzdrQ1B1OFZQTGxXM0w3ek0zTHZYYkFPbWRKb1JqYXRrVk1oUjZoT1IwMHNuUTlTL3ZIR0FSaEx6bkptVFpFR0RlbmUyNzV3MVBocllwZ1M0Njc1UG90Q09HNHlCYzBxY0dOb3ZlY05QN3ZnaEdZMzBjdzhzaFdVY0oiLCJtYWMiOiJhMDgxMjNiZWZiMjUxMWQ4ZmU1OWFmMzE0ZWY5MTc3NGFhM2Y3MWUyZmY1N2IxZjY2MTM2N2VkY2Y4N2Y4ZTU1IiwidGFnIjoiIn0%3D'
      })
    };
    return this.http.post<CommonListResponse<AppUser>>(`${environment.apiUrl}newPassword`, { item }, options)
      .pipe(
        map(response => {
          return response;
        }));
  }

  resetPassword(item)
  {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': '*/*',
        //'X-XSRF-TOKEN': 'eyJpdiI6IjEvRy9sWkpnVGJiVGxGQ0NkbzRJaUE9PSIsInZhbHVlIjoiZFZXWDA1RzdrQ1B1OFZQTGxXM0w3ek0zTHZYYkFPbWRKb1JqYXRrVk1oUjZoT1IwMHNuUTlTL3ZIR0FSaEx6bkptVFpFR0RlbmUyNzV3MVBocllwZ1M0Njc1UG90Q09HNHlCYzBxY0dOb3ZlY05QN3ZnaEdZMzBjdzhzaFdVY0oiLCJtYWMiOiJhMDgxMjNiZWZiMjUxMWQ4ZmU1OWFmMzE0ZWY5MTc3NGFhM2Y3MWUyZmY1N2IxZjY2MTM2N2VkY2Y4N2Y4ZTU1IiwidGFnIjoiIn0%3D'
      })
    };
    return this.http.post<CommonListResponse<AppUser>>(`${environment.apiUrl}resetPassword`, { item }, options)
      .pipe(
        map(response => {
          return response;
        }));
  }

  login(email, password, rememberMe) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        // Con `*/*`, `Request::isJson()` da falso en Laravel, el cuerpo no se parsea y
        // `input()` solo encontraba las credenciales en el query string, donde quedan
        // escritas en claro en los logs de acceso. Con `application/json` se leen del cuerpo.
        'Content-Type': 'application/json',
        //'X-XSRF-TOKEN': 'eyJpdiI6IjEvRy9sWkpnVGJiVGxGQ0NkbzRJaUE9PSIsInZhbHVlIjoiZFZXWDA1RzdrQ1B1OFZQTGxXM0w3ek0zTHZYYkFPbWRKb1JqYXRrVk1oUjZoT1IwMHNuUTlTL3ZIR0FSaEx6bkptVFpFR0RlbmUyNzV3MVBocllwZ1M0Njc1UG90Q09HNHlCYzBxY0dOb3ZlY05QN3ZnaEdZMzBjdzhzaFdVY0oiLCJtYWMiOiJhMDgxMjNiZWZiMjUxMWQ4ZmU1OWFmMzE0ZWY5MTc3NGFhM2Y3MWUyZmY1N2IxZjY2MTM2N2VkY2Y4N2Y4ZTU1IiwidGFnIjoiIn0%3D'
      })
    };
    return this.http.post<CommonListResponse<AppUser>>(`${environment.apiUrl}login`, { email, password }, options)
      .pipe(
        map(response => {
          this.storageService.removeItem('currentUser');
          if (response.isSuccessful) {
            // `currentUser` es de donde la aplicación saca id, roles y sedes: lo leen
            // más de treinta componentes sin comprobar nulo. No puede depender de la
            // casilla «Recuérdame». El token queda solo en sessionStorage.
            const { accessToken, password, ...perfil } = response.data[0] as AppUser & { password?: string };
            sessionStorage.setItem('accessToken', accessToken);
            this.storageService.setItem('currentUser', JSON.stringify(perfil));
            this.recordarCorreo(email, rememberMe);
            this.masterService.getAllMasters();
            this.currentUserSubject.next(response);
          }
          return response;
        }));
  }

  /**
   * Guarda el correo y la elección de la casilla, o los borra si se ha
   * desmarcado. Solo se aplica tras un login correcto: un intento fallido no
   * debe tirar el correo que ya estaba guardado.
   */
  private recordarCorreo(email: string, rememberMe: boolean): void {
    this.storageService.setItem(AuthenticationService.REMEMBER_ME, JSON.stringify(!!rememberMe));
    if (rememberMe)
      this.storageService.setItem(AuthenticationService.REMEMBERED_EMAIL, email);
    else
      this.storageService.removeItem(AuthenticationService.REMEMBERED_EMAIL);
  }

  logout(): void {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('accessToken')
      })
    };
    this.http.get<any>(`${environment.apiUrl}logOut`, options)
      .subscribe(() => {
        sessionStorage.removeItem('accessToken');
        this.limpiarConservandoCorreo();
        this.currentUserSubject.next(null);
        this.router.navigate(['/login']);
      });
  }

  /**
   * `clear()` vacía el localStorage entero. El correo recordado y la elección de
   * la casilla tienen que sobrevivir al cierre de sesión: son justo lo único que
   * el usuario ha pedido que se recuerde.
   */
  private limpiarConservandoCorreo(): void {
    const conservados = [AuthenticationService.REMEMBER_ME, AuthenticationService.REMEMBERED_EMAIL]
      .map(clave => [clave, localStorage.getItem(clave)] as const)
      .filter(([, valor]) => valor !== null);

    this.storageService.clear();

    conservados.forEach(([clave, valor]) => this.storageService.setItem(clave, valor));
  }

}